import { PropTypes } from "@l2r-front/l2r-proptypes"

export const reportStepConfig = PropTypes.shape({
    title: PropTypes.string.isRequired,
    toggle: PropTypes.shape({
        title: PropTypes.string.isRequired,
        active: PropTypes.oneOf(["close", "next"]),
    }),
    type: PropTypes.string.isRequired,
})